import { PayloadAction } from '@reduxjs/toolkit';

import { SpreadDesignTemplate, TemplatesState } from 'editor/src/store/editorModules/templates/types';

const setTemplatesReducer = (state: TemplatesState, action: PayloadAction<SpreadDesignTemplate[]>) => {
  state.designTemplates = action.payload;
};

export default setTemplatesReducer;
